import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-house-cracked-icon"
};
const _hoisted_1 = {
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3154_551)"><path opacity="0.4" d="M16.7769 8.45379V13.9997C16.7769 15.1043 15.8815 15.9997 14.7769 15.9997H10.769L9.52296 14.2731L12.7767 12.2731L8.15199 7.9997L10.0308 11.7263L6.77705 13.7263L7.94105 15.9997H4.77783C3.67327 15.9997 2.77783 15.1043 2.77783 13.9997V8.45332L9.77711 2.3291L16.7769 8.45379Z"></path><path d="M18.4365 7.24713L16.7776 5.79572V1.4995C16.7776 1.22363 16.554 0.9995 16.2776 0.9995H14.2778C14.0015 0.9995 13.7778 1.22363 13.7778 1.4995V3.17103L10.4365 0.247562C10.2481 0.0825312 10.0129 0 9.77783 0C9.54274 0 9.30761 0.0825312 9.11914 0.247562L1.11914 7.24713C0.860832 7.47359 0.777832 7.77009 0.777832 8.00025C0.777832 8.75875 1.46499 8.99994 1.77783 9C2.01149 9 2.24627 8.91863 2.43652 8.75288L9.77783 2.32941L17.1191 8.75288C17.3091 8.91888 17.544 8.99994 17.7773 8.99994C18.0848 8.99994 18.7778 8.75856 18.7778 8.00025C18.7778 7.76966 18.6944 7.47319 18.4365 7.24713ZM8.15271 8L10.0315 11.7266L6.77777 13.7266L7.94177 16H10.7697L9.52368 14.2734L12.7774 12.2734L8.15271 8Z"></path></g><defs><clipPath id="clip0_3154_551"><rect width="18" height="16" fill="white" transform="translate(0.777832)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitHouseCrackedIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitHouseCrackedIcon as default
};
//# sourceMappingURL=uikit-house-cracked-icon.vue.es.js.map
